export const tooltips = {
  trendingTopics:
    'This section highlights the most frequent topics of inquiries handled by VoiceSphere AI, helping you understand customer concerns and trends.',
  languageDistribution:
    'This pie chart shows the distribution of call languages, enabling you to see which languages are most commonly used by customers.',
  csatScore:
    'The Customer Satisfaction (CSAT) Score reflects the overall satisfaction of customers with the AI and human agents. Higher scores indicate better performance.',
};
